<template>
  <div>
    <dod-view-title :title="title" />
    <div class="flex">
      <DodCustomInput
        label="IMIĘ"
        :isRequired="true"
        custom-placeholder="Imię"
        :customId="`name-input${title}`"
        :class="extended ? 'small-input' : 'bigger-input'"
        :prePickedValue="this.userData.name"
        :errorMsg="
          errorsObj
            ? isClient
              ? errorsObj.clientFirstName
              : errorsObj.firstName
            : ''
        "
        @onType="(e) => onInputChange('name', e)"
      />
      <DodCustomInput
        label="NAZWISKO"
        :isRequired="true"
        custom-placeholder="Nazwisko"
        :customId="`surname-input${title}`"
        :class="extended ? 'small-input' : 'bigger-input'"
        :prePickedValue="this.userData.surname"
        :errorMsg="
          errorsObj
            ? isClient
              ? errorsObj.clientLastName
              : errorsObj.lastName
            : ''
        "
        @onType="(e) => onInputChange('surname', e)"
      />
      <DodCustomInput
        label="TELEFON"
        :isRequired="true"
        custom-placeholder="Telefon (9 cyfr)"
        :customId="`phone-input${title}`"
        class="medium-input"
        :digitsOnly="true"
        :maxLength="9"
        :prePickedValue="this.userData.phone"
        :errorMsg="
          errorsObj ? (isClient ? errorsObj.clientPhone : errorsObj.phone) : ''
        "
        @onType="(e) => onInputChange('phone', e)"
      />
      <DodCustomInput
        v-if="isClient"
        label="EMAIL"
        :isRequired="false"
        custom-placeholder="Email"
        :customId="`clientEmail-input${title}`"
        class="medium-input"
        :prePickedValue="this.userData.clientEmail"
        :errorMsg="
          errorsObj
            ? isClient
              ? errorsObj.clientEmail
              : errorsObj.clientEmail
            : ''
        "
        @onType="(e) => onInputChange('clientEmail', e)"
      />

      <DodCustomInput
        v-if="extended"
        label="EMAIL"
        :isRequired="false"
        custom-placeholder="Email"
        :customId="`email-input${title}`"
        class="medium-input"
        :prePickedValue="this.userData.email"
        :errorMsg="errorsObj.email"
        @onType="(e) => onInputChange('email', e)"
      />

      <DodCustomInput
        v-if="extended"
        label="OBYWATELSTWO"
        :isRequired="true"
        custom-placeholder="Obywatelstwo"
        :customId="`citizenship-input${title}`"
        class="medium-input"
        :prePickedValue="this.userData.citizenship"
        :errorMsg="errorsObj.citizenship"
        @onType="(e) => onInputChange('citizenship', e)"
      />

      <DodCustomInput
        v-if="extended"
        label="PESEL"
        :isRequired="true"
        custom-placeholder="Pesel"
        :customId="`phone-input${title}`"
        class="bigger-input"
        :prePickedValue="this.extendedUserData.pesel"
        :errorMsg="errorsObj ? errorsObj.pesel : ''"
        @onType="(e) => onInputChange('pesel', e)"
        @onBlur="onPeselChange"
      />
      <DodCustomInput
        v-if="extended"
        label="DATA URODZENIA"
        :isRequired="true"
        custom-placeholder="YYYY-MM-DD"
        :customId="`phone-input${title}`"
        class="bigger-input"
        :prePickedValue="this.extendedUserData.birthdate"
        :errorMsg="errorsObj ? errorsObj.birthDate : ''"
        @onType="(e) => onInputChange('birthdate', e)"
      />
      <DodCustomInput
        v-if="extended"
        label="URZĄD SKARBOWY"
        :isRequired="true"
        custom-placeholder="Urząd skarbowy"
        :customId="`phone-input${title}`"
        class="medium-input"
        :prePickedValue="this.extendedUserData.taxOffice"
        :errorMsg="errorsObj ? errorsObj.taxOffice : ''"
        @onType="(e) => onInputChange('taxOffice', e)"
      />
      <DodCustomInput
        v-if="extended"
        label="NR DOWODU"
        :isRequired="true"
        custom-placeholder="Nr i seria dowodu osobistego"
        :customId="`phone-input${title}`"
        class="bigger-input"
        :prePickedValue="this.extendedUserData.idNumber"
        :errorMsg="errorsObj ? errorsObj.idNumber : ''"
        @onType="(e) => onInputChange('idNumber', e)"
      />
      <DodCustomInput
        v-if="extended"
        label="NR PASZPORTU"
        custom-placeholder="Nr paszportu"
        :customId="`phone-input${title}`"
        class="bigger-input"
        :prePickedValue="this.extendedUserData.passportId"
        :errorMsg="errorsObj ? errorsObj.passportNumber : ''"
        @onType="(e) => onInputChange('passportId', e)"
      />
      <div v-if="extended" class="medium-input">
        <p class="input-label">ODDZIAŁ NFZ</p>
        <custom-select
          :options="nfzDepartments"
          :default-value="'Wybierz oddział'"
          :graySelect="true"
          :isAutocomplete="true"
          :prePick="this.extendedUserData.careOption"
          :large="true"
          @newPick="handleNfzDepartment"
        />
      </div>
      <div style="width: 100%; margin-bottom: 35px">
        <label :for="`my-input-searchbox${title}`">Adres</label>
        <input
          type="text"
          :id="`my-input-searchbox${title}`"
          class="form-control cityInput mapInput"
          placeholder="Wprowadź adres (miasto, ulica, numer budynku)"
        />
      </div>
      <DodCustomInput
        label="MIEJSCOWOŚĆ"
        :isRequired="true"
        custom-placeholder="Miejscowość"
        :customId="`city-input${title}`"
        class="bigger-input"
        :prePickedValue="this.userData.city"
        :errorMsg="
          errorsObj ? (isClient ? errorsObj.clientCity : errorsObj.city) : ''
        "
        @onType="(e) => onInputChange('city', e)"
      />
      <DodCustomInput
        label="ULICA"
        custom-placeholder="Ulica"
        :customId="`street-input${title}`"
        class="bigger-input"
        :prePickedValue="this.userData.street"
        @onType="(e) => onInputChange('street', e)"
      />
      <DodCustomInput
        label="NR BUDYNKU"
        :isRequired="true"
        custom-placeholder="Nr budynku"
        :customId="`building-input${title}`"
        class="small-input"
        :prePickedValue="this.userData.buildingNumber"
        :errorMsg="
          errorsObj
            ? isClient
              ? errorsObj.clientStreetNumber
              : errorsObj.streetNumber
            : ''
        "
        @onType="(e) => onInputChange('buildingNumber', e)"
      />
      <DodCustomInput
        label="NR MIESZKANIA"
        custom-placeholder="Nr mieszkania"
        :customId="`home-number-input${title}`"
        class="small-input"
        :prePickedValue="this.userData.houseNumber"
        @onType="(e) => onInputChange('houseNumber', e)"
      />
      <DodCustomInput
        label="KOD POCZTOWY"
        custom-placeholder="Kod pocztowy"
        :customId="`postal-code--input${title}`"
        class="bigger-input"
        :prePickedValue="this.userData.postalCode"
        @onType="(e) => onInputChange('postalCode', e)"
      />
      <DodCustomInput
        v-if="withSocialWorkerPhone"
        label="TELEFON DO PRACOWNIKA SOCJALNEGO"
        custom-placeholder="Telefon do pracownika socjalnego (9 cyfr)"
        :customId="`social-worker-phone-input${title}`"
        class="medium-input"
        :digitsOnly="true"
        :maxLength="9"
        :prePickedValue="this.userData.socialWorkerPhone"
        :errorMsg="errorsObj ? errorsObj.socialWorkerPhone : ''"
        @onType="(e) => onInputChange('socialWorkerPhone', e)"
      />
      <DodCustomInput
        v-if="withRegion"
        label="REJON"
        :isRequired="true"
        custom-placeholder="Rejon"
        :customId="`region-input${title}`"
        class="medium-input"
        :maxLength="10"
        :prePickedValue="this.userData.region"
        :errorMsg="errorsObj ? errorsObj.region : ''"
        @onType="(e) => onInputChange('region', e)"
      />
    </div>
  </div>
</template>

<script>
import DodCustomInput from "./DodCustomInput.vue";
import DodViewTitle from "./DodViewTitle.vue";
import CustomSelect from "../CustomSelect.vue";
import gmapsInit from "../../gmaps";
import { validatePolish } from "validate-polish";
export default {
  components: {
    DodCustomInput,
    DodViewTitle,
    CustomSelect,
  },
  // withSocialWorkerPhone / withRegion - pola tylko dla podopiecznego (SAPP00018, SAPP00023);
  // ten sam formularz obsługuje też opiekunów i dane klienta, tam tych pól nie ma.
  props: [
    "title",
    "extended",
    "errorsObj",
    "isClient",
    "prePick",
    "withSocialWorkerPhone",
    "withRegion",
  ],
  emits: ["userDataChange"],
  data() {
    return {
      userData: {
        name: this.prePick ? this.prePick.name : "",
        surname: this.prePick ? this.prePick.surname : "",
        phone: this.prePick ? this.prePick.phone : "",
        city: this.prePick ? this.prePick.city : "",
        street: this.prePick ? this.prePick.street : "",
        buildingNumber: this.prePick ? this.prePick.buildingNumber : "",
        houseNumber: this.prePick ? this.prePick.houseNumber : "",
        latitude: "",
        longitude: "",
        postalCode: this.prePick ? this.prePick.postalCode : "",
        socialWorkerPhone: this.prePick ? this.prePick.socialWorkerPhone : "",
        region: this.prePick ? this.prePick.region : "",
        citizenship: this.prePick ? this.prePick.citizenship : "",
        email: this.prePick ? this.prePick.email : "",
        clientEmail: this.prePick ? this.prePick.clientEmail : "",
      },
      extendedUserData: {
        pesel: this.prePick ? this.prePick.pesel : "",
        birthdate: this.prePick ? this.prePick.birthdate : "",
        taxOffice: this.prePick ? this.prePick.taxOffice : "",
        idNumber: this.prePick ? this.prePick.idNumber : "",
        passportId: this.prePick ? this.prePick.passportId : "",
        careOption: this.prePick ? this.prePick.careOption : "",
      },
      nfzDepartments: [
        {
          name: "Łódzki Oddział Wojewódzki NFZ",
          value: "Łódzki Oddział Wojewódzki NFZ",
          shortName: "Łódzki Oddział Wojewódzki NFZ",
        },
        {
          name: "Dolnośląski Oddział Wojewódzki NFZ",
          value: "Dolnośląski Oddział Wojewódzki NFZ",
          shortName: "Dolnośląski Oddział Wojewódzki NFZ",
        },
        {
          name: "Kujawsko-Pomorski Oddział Wojewódzki NFZ",
          value: "Kujawsko-Pomorski Oddział Wojewódzki NFZ",
          shortName: "Kujawsko-Pomorski Oddział Wojewódzki NFZ",
        },
        {
          name: "Lubelski Oddział Wojewódzki NFZ",
          value: "Lubelski Oddział Wojewódzki NFZ",
          shortName: "Lubelski Oddział Wojewódzki NFZ",
        },
        {
          name: "Lubuski Oddział Wojewózki NFZ",
          value: "Lubuski Oddział Wojewózki NFZ",
          shortName: "Lubuski Oddział Wojewózki NFZ",
        },
        {
          name: "Małopolski Oddział Wojewódzki NFZ",
          value: "Małopolski Oddział Wojewódzki NFZ",
          shortName: "Małopolski Oddział Wojewódzki NFZ",
        },
        {
          name: "Mazowiecki Oddział Wojewódzki NFZ",
          value: "Mazowiecki Oddział Wojewódzki NFZ",
          shortName: "Mazowiecki Oddział Wojewódzki NFZ",
        },
        {
          name: "Opolski Oddział Wojewódzki NFZ",
          value: "Opolski Oddział Wojewódzki NFZ",
          shortName: "Opolski Oddział Wojewódzki NFZ",
        },
        {
          name: "Podkarpacki Oddział Wojewódzki NFZ",
          value: "Podkarpacki Oddział Wojewódzki NFZ",
          shortName: "Podkarpacki Oddział Wojewódzki NFZ",
        },
        {
          name: "Podlaski Oddział Wojewódzki NFZ",
          value: "Podlaski Oddział Wojewódzki NFZ",
          shortName: "Podlaski Oddział Wojewódzki NFZ",
        },
        {
          name: "Pomorski Oddział Wojewódzki NFZ",
          value: "Pomorski Oddział Wojewódzki NFZ",
          shortName: "Pomorski Oddział Wojewódzki NFZ",
        },
        {
          name: "Ślaski Oddział Wojewódzki NFZ",
          value: "Ślaski Oddział Wojewódzki NFZ",
          shortName: "Ślaski Oddział Wojewódzki NFZ",
        },
        {
          name: "Świętokrzyski Oddział Wojewódzki NFZ",
          value: "Świętokrzyski Oddział Wojewódzki NFZ",
          shortName: "Świętokrzyski Oddział Wojewódzki NFZ",
        },
        {
          name: "Warmińsko-mazurski Oddział Wojewódzki NFZ",
          value: "Warmińsko-mazurski Oddział Wojewódzki NFZ",
          shortName: "Warmińsko-mazurski Oddział Wojewódzki NFZ",
        },
        {
          name: "Wielkopolski Oddział Wojewódzki NFZ",
          value: "Wielkopolski Oddział Wojewódzki NFZ",
          shortName: "Wielkopolski Oddział Wojewódzki NFZ",
        },
        {
          name: "Zachodniopomorski Oddział Wojewódzki NFZ",
          value: "Zachodniopomorski Oddział Wojewódzki NFZ",
          shortName: "Zachodniopomorski Oddział Wojewódzki NFZ",
        },
      ],
    };
  },
  methods: {
    getBirthYear(pesel) {
      const year = 10 * parseInt(pesel[0]) + parseInt(pesel[1]);
      const month = 10 * parseInt(pesel[2]) + parseInt(pesel[3]);

      if (month > 80 && month < 93) {
        return 1800 + year;
      } else if (month > 0 && month < 13) {
        return 1900 + year;
      } else if (month > 20 && month < 33) {
        return 2000 + year;
      } else if (month > 40 && month < 53) {
        return 2100 + year;
      } else if (month > 60 && month < 73) {
        return 2200 + year;
      }
    },

    getBirthMonth(pesel) {
      const month = 10 * parseInt(pesel[2]) + parseInt(pesel[3]);
      if (month > 80 && month < 93) {
        return month - 80;
      } else if (month > 20 && month < 33) {
        return month - 20;
      } else if (month > 40 && month < 53) {
        return month - 40;
      } else if (month > 60 && month < 73) {
        return month - 60;
      } else {
        return month;
      }
    },

    getBirthDay(pesel) {
      return 10 * parseInt(pesel[4]) + parseInt(pesel[5]);
    },

    onPeselChange(peselNumber) {
      if (validatePolish.pesel(peselNumber)) {
        const year = this.getBirthYear(peselNumber);
        const month = this.getBirthMonth(peselNumber);
        const day = this.getBirthDay(peselNumber);
        const birthDateFromPesel = `${year}-${
          month < 10 ? "0" + month : month
        }-${day < 10 ? "0" + day : day}`;
        this.extendedUserData.birthdate = birthDateFromPesel;
      }
    },
    handleNfzDepartment(nfzDepartment) {
      this.extendedUserData.careOption = nfzDepartment;
    },
    onInputChange(userDataKey, value) {
      if (Object.keys(this.userData).includes(userDataKey)) {
        this.userData[`${userDataKey}`] = value;
      } else {
        this.extendedUserData[`${userDataKey}`] = value;
      }
      this.$emit("userDataChange", {
        ...this.userData,
        ...(this.extended ? this.extendedUserData : {}),
      });
    },
  },
  async mounted() {
    const google = await gmapsInit();
    const input = document.getElementById(`my-input-searchbox${this.title}`);
    const searchBox = new google.maps.places.SearchBox(input);
    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();

      if (!places || places.length == 0) {
        return;
      }
      let lat = places[0].geometry.location.lat();
      let lng = places[0].geometry.location.lng();
      const newCity = places[0].address_components.find((e) =>
        e.types.includes("locality")
      );
      const newStreet = places[0].address_components.find((e) =>
        e.types.includes("route")
      );
      const newPostalCode = places[0].address_components.find((e) =>
        e.types.includes("postal_code")
      );
      const newStreetNumber = places[0].address_components.find((e) =>
        e.types.includes("street_number")
      );

      this.userData.city = newCity ? newCity.long_name : "";
      this.userData.street = newStreet ? newStreet.long_name : "";
      this.userData.postalCode = newPostalCode ? newPostalCode.long_name : "";
      this.userData.latitude = lat || "";
      this.userData.longitude = lng || "";
      this.userData.buildingNumber = newStreetNumber
        ? newStreetNumber.long_name
        : "";
      this.$emit("userDataChange", {
        ...this.userData,
        ...(this.extended ? this.extendedUserData : {}),
      });
    });
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 !important;
}

.flex .bigger-input,
.flex .medium-input,
flex small-input {
  margin-bottom: 35px;
}
.input-label {
  color: #090741;
  font-size: 14px;
  font-weight: 500;
  padding-left: 5px;
  margin-bottom: 0;
  margin-top: -5px;
}
label,
input {
  display: block;
  width: 100%;
  color: #090741;
  font-size: 14px;
  border: unset;
  padding: 0;
  outline: none;
}
label {
  font-weight: 500;
}
.is-required {
  color: #e2037e;
}
input {
  border-bottom: 1px solid #c1c1cf;
  padding-bottom: 5px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #090741;
}
</style>
